import HomeEN from './en-US/home.json';
import a11yEN from '@monorepo/shared/src/translations/en-US/a11y.json';
import MenuEN from './en-US/menu.json';
import messagingEN from './en-US/messaging.json';
import assignmentEN from './en-US/assignment.json';
import tourEN from './en-US/tour.json';
import uiEN from './en-US/ui.json';
import altEN from './en-US/alt.json';
import letterTeachingEN from './en-US/letterTeaching.json';
import TeachingOrderEN from './en-US/teaching-order.json';
import toolsEN from './en-US/tools.json';
import ResourcesEN from './en-US/resources.json';
import CommonEN from './en-US/common.json';
import ModalEN from './en-US/modal.json';
import PageNavigationEN from './en-US/page-navigation.json';
import LetterBooksEN from '@monorepo/shared/src/translations/en-US/letter-books.json';
import ClassroomBooksEN from './en-US/classroom-books.json';
import PreferencesEN from './en-US/preferences.json';
import HelpAndSupportEN from './en-US/help-and-support.json';
import ReportsEN from './en-US/reports.json';
import ClassroomEN from './en-US/classroom.json';
import ProfessionalLearningEN from './en-US/professional-learning.json';

import letterTeachingES from './es-US/letterTeaching.json';
import messagingES from './es-US/messaging.json';
import assignmentES from './es-US/assignment.json';
import tourES from './es-US/tour.json';
import uiES from './es-US/ui.json';
import altES from './es-US/alt.json';
import HomeES from './es-US/home.json';
import a11yEs from '@monorepo/shared/src/translations/es-US/a11y.json';
import MenuES from './es-US/menu.json';
import toolsES from './es-US/tools.json';
import TeachingOrderES from './es-US/teaching-order.json';
import ResourcesES from './es-US/resources.json';
import CommonES from './es-US/common.json';
import ModalES from './es-US/modal.json';
import PageNavigationES from './es-US/page-navigation.json';
import LetterBooksES from '@monorepo/shared/src/translations/es-US/letter-books.json';
import ClassroomBooksES from './es-US/classroom-books.json';
import PreferencesES from './es-US/preferences.json';
import HelpAndSupportES from './es-US/help-and-support.json';
import ReportsES from './es-US/reports.json';
import ClassroomES from './es-US/classroom.json';
import ProfessionalLearningES from './es-US/professional-learning.json';

const i18n = {
  resourceMap: {
    'en-US': {
      a11y: a11yEN,
      menu: MenuEN,
      teachingOrder: TeachingOrderEN,
      resources: ResourcesEN,
      common: CommonEN,
      home: HomeEN,
      modal: ModalEN,
      tools: toolsEN,
      messaging: messagingEN,
      assignment: assignmentEN,
      tour: tourEN,
      ui: uiEN,
      alt: altEN,
      letterTeaching: letterTeachingEN,
      pageNavigation: PageNavigationEN,
      letterBooks: LetterBooksEN,
      classroomBooks: ClassroomBooksEN,
      preferences: PreferencesEN,
      helpAndSupport: HelpAndSupportEN,
      reports: ReportsEN,
      classroom: ClassroomEN,
      professionalLearning: ProfessionalLearningEN,
    },
    'es-US': {
      a11y: a11yEs,
      menu: MenuES,
      teachingOrder: TeachingOrderES,
      resources: ResourcesES,
      common: CommonES,
      home: HomeES,
      modal: ModalES,
      tools: toolsES,
      messaging: messagingES,
      assignment: assignmentES,
      tour: tourES,
      ui: uiES,
      alt: altES,
      letterTeaching: letterTeachingES,
      pageNavigation: PageNavigationES,
      letterBooks: LetterBooksES,
      classroomBooks: ClassroomBooksES,
      preferences: PreferencesES,
      helpAndSupport: HelpAndSupportES,
      reports: ReportsES,
      classroom: ClassroomES,
      professionalLearning: ProfessionalLearningES,
    },
  },
};

export default i18n;
